import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-newtask',
  templateUrl: './newtask.component.html',
  styleUrls: ['./newtask.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class NewtaskComponent implements OnInit {

  constructor(public parent: ManagementComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetUsersFiltered(value);
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  SearchTerm:string;
  Users:any[];
  SeverityTypes:any[];
  InternalTaskStatuses:any[];
  InternalTaskEvents:any[];
  Task: {[k: string]: any} = {};
  Comment: {[k: string]: any} = {};
  TaskID:string;
  InitialLoading:boolean;
  Locked:boolean;
  CompletedStatus:any;
  PrefferedAssignees:any[];

  MaxExpectedResolveDate = new FormControl(moment());

  ngOnInit(): void {
    this.Locked = false;
    this.InitialLoading = false;
    this.GetInternalTasksMasterData();
    this.getParamValues();
    this.Comment = null;
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['id']){
        this.TaskID = params['id'];
        this.GetInternalTask(this.TaskID, true, true);
      }
      else{
        this.GenerateInitialTaskForUI();
      }
    });
  }

  GetInternalTask(taskID:string, withDetails:boolean, withObjectInfo:boolean){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      TaskID:taskID,
      WithDetails:withDetails,
      WithObjectInfo:withObjectInfo
    };
  
   this.InitialLoading = true;
  
   this.service.GetInternalTask(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
      this.Task = response["InternalTask"];
     }
     else if(response["Status"] == 1){
       this.Task = response["InternalTask"];

       if(this.parent.User.Id != this.Task.Owner.Id && this.Task.Locked == true){
        this.Locked = true;
       }
     }
  
     this.InitialLoading = false;
    });
   }

  GetInternalTasksMasterData(){
   var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage()
  };

 this.parent.loading = true;

 this.service.GetInternalTasksMasterData(request).subscribe(response => {

   if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    this.SeverityTypes = response["SeverityTypes"];
    this.InternalTaskStatuses = response["InternalTaskStatuses"];
    this.InternalTaskEvents = response["InternalTaskEvents"];

    this.CompletedStatus = JSON.parse(JSON.stringify(this.InternalTaskStatuses[2]));
   }

   this.parent.loading = false;
  });
  }

  GetUsersFiltered(searchTerm:string){
    
    if(searchTerm != null){
     if(searchTerm.length > 2){
       var request = {
         User:this.parent.User,
         Language:this.parent.getLanguage(),
         SearchTerm:searchTerm,
       };
   
       this.parent.loading = true;
   
       this.service.GetUsersFiltered(request).subscribe(response => {
      
         if(response["Status"] != 1){
         
         }
         else if(response["Status"] == 1){
           this.Users = response["Users"];
         }
      
         this.parent.loading = false;
       });
     }
    }
   }

   GenerateInitialTaskForUI(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.service.GenerateInitialTaskForUI(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Task = response["Task"];
    }
 
    this.parent.loading = false;
   });
   }

   AddUserToTask(u:any){
    if(this.Task.Assignees.some(x => x.Id == u.Id) == false){
      this.Task.Assignees.push(JSON.parse(JSON.stringify(u)));
    }

    this.Users = [];
    this.SearchTerm = "";
   }

   RemoveUserFromTask(u:any){
    this.Task.Assignees = this.Task.Assignees.filter(x => x.Id != u.Id);
   }

   InitializeNewComment(finalize:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      IsClosingComment:finalize
    };
  
   this.parent.loading = true;
  
   this.service.GenerateInitialCommentForUI(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.Comment = response["Comment"];

       if(this.Task.ID != null){
        this.Comment.ParentID = this.Task.ID;
       }
     }
  
     this.parent.loading = false;
    });
   }

   VoidComment(){
    this.Comment = null;
   }

   AddNewCommentary(){
    if(this.Comment != null && this.Comment.Comment.length > 0){

      this.Task.Comments.push(JSON.parse(JSON.stringify(this.Comment)));

      if(this.Task.ID != null){
        var request = {
          User:this.parent.User,
          Language:this.parent.getLanguage(),
          InternalTaskComment:this.Comment
        };
      
       this.parent.loading = true;
      
       this.service.AddUpdateInternalTaskComment(request).subscribe(response => {
      
         if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
         }
         else if(response["Status"] == 1){
         }
      
         this.parent.loading = false;
        });
      }

      this.Comment = null;
    }
   }

   ShowFinalCommentAddingContainer:boolean;

   AddInternalTask(finalize:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Task:this.Task
    };

   this.parent.loading = true;
  
   this.service.AddInternalTask(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       this.Task = response["Task"];

       if(finalize){
        this.FinalizeTask();
       }
       else{
        this.ViewTask(this.Task.ID);
       }
     }
  
     this.parent.loading = false;
    });
   }

   FinalizeTask(){
    this.Task.Status = JSON.parse(JSON.stringify(this.CompletedStatus));
    this.Task.Locked = true;
    this.ShowFinalCommentAddingContainer = true;
    this.InitializeNewComment();
   }

   ViewTask(ID:string){
    this.router.navigate(['/management/newtask'], { queryParams: { id: ID } }); 
   }

   UpdateInternalTask(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Task:this.Task
    };
  
   this.parent.loading = true;
  
   this.service.UpdateInternalTask(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       this.Task = response["Task"];
     }
  
     this.parent.loading = false;
    });
   }

   DeletingCommentID:string;
   DeleteCommentContainer:boolean;
   CurrentComment:any;

   OpenDeleteComment(c:any){
    this.CurrentComment = JSON.parse(JSON.stringify(c));
    this.DeletingCommentID = c.UIID;
    this.DeleteCommentContainer = true;
   }

   DeleteComment(){
    this.Task.Comments = this.Task.Comments.filter(x => x.UIID != this.DeletingCommentID);

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Comment:this.CurrentComment
    };
  
   this.parent.loading = true;
  
   this.service.DeleteInternalTaskComment(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
     }
     else if(response["Status"] == 1){
     }
  
     this.parent.loading = false;
    });
   }

   LockInternalTask(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      TaskID:this.Task.ID,
      LockState:this.Task.Locked
    };
  
   this.parent.loading = true;
  
   this.service.LockInternalTask(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-management-app");
     }
     else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-management-app", 10000);
     }
  
     this.parent.loading = false;
    });
   }

   TaskStatusChangeMessageContainer:boolean;
   TaskStatusChangeResponse:any;

   GenerateUIMessageOnStatusChange(){
    
    if(this.Task.Status.ID != 1){
      this.Task.Locked = false;
      this.Locked = false;
    }
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InternalTask:this.Task
    };
  
   this.parent.loading = true;
  
   this.service.GenerateUIMessageOnStatusChange(request).subscribe(response => {
  
     if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.TaskStatusChangeMessageContainer = true;
     }

     this.TaskStatusChangeResponse = response;
     this.parent.loading = false;
    });
   }

   UpdateInternalTaskStatus(){

    if(this.Task.ID == null || this.Task?.ID?.length == 0){
      return;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Task:this.Task,
    };
  
   this.parent.loading = true;
  
   this.service.UpdateInternalTaskStatus(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.TaskStatusChangeMessageContainer = true;
     }

     this.TaskStatusChangeResponse = response;
     this.parent.loading = false;
    });
   }

   SendInternalTaskEmailNotification(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      InternalTask:this.Task,
      EmailNotificationMessage:this.EmailNotificationMessage,
      Recipients:this.PrefferedAssignees,
      SMTPConfig:this.CurrentSMTP,
      Senders:this.SMTPEmails,
      EmailSubject:this.EmailSubject
    };
  
   this.parent.loading = true;
  
   this.service.SendInternalTaskEmailNotification(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       
     }

     this.parent.loading = false;
    });
   }

   ShowEmailNotificationContainer:boolean;
   EmailNotificationMessage:string;

   RemoveUserFromMessage(u:any){
    this.PrefferedAssignees = this.PrefferedAssignees.filter(x => x.Id != u.Id);
   }

   OpenSendEmailNotificationContainer(){
    this.PrefferedAssignees = JSON.parse(JSON.stringify(this.Task.Assignees));
    this.ShowEmailNotificationContainer = true;
    this.GetCompanySMTPConfigs(this.parent.getLanguage());
    this.GetInternalTaskEmailNotificationSubject();
   }

SMTPConfigs:any[];
CurrentSMTP:any;
SMTPEmails:any[];
CurrentSMTPEmail:any;
EmailMessage:any;
EmailSubject:string;

GetCompanySMTPConfigs(Language:string){
  var request = {
    User:this.parent.User,
    Language:Language,
    UILanguage:this.parent.getLanguage(),
    CompanyID:this.parent.Company.ID
  };

  this.parent.loading = true;

  this.service.GetCompanySMTPConfigs(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPConfigs = response["SMTPConfigs"];

      if(this.SMTPConfigs.length > 0){
        this.CurrentSMTP = this.SMTPConfigs[0];
        this.GetCompanySMTPEmails(this.CurrentSMTP.ID, Language);
      }
    }
   
    this.parent.loading = false;
  });
}

GetCompanySMTPEmails(SMTPID:any, Language:string){
  var request = {
    User:this.parent.User,
    Language:Language,
    UILanguage:this.parent.getLanguage(),
    SMTPID:SMTPID
  };

  this.parent.loading = true;

  this.service.GetCompanySMTPEmails(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPEmails = response["Emails"];

      this.SMTPEmails.forEach(e => {
        if(e.Email == this.parent.User.Email){
          e.IsDefault = true;
        }
      });
    }
   
    this.parent.loading = false;
  });
}

SelectSMTPEmail(model:any){
  this.SMTPEmails.forEach(e => {
    if(e.ID == model.ID){
      e.IsDefault = true;
    }
    else{
      e.IsDefault = false;
    }
  });
}

GetInternalTaskEmailNotificationSubject(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    TaskID:this.Task.ID
  };

  this.parent.loading = true;

  this.service.GetInternalTaskEmailNotificationSubject(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.EmailSubject = response["EmailSubject"];
    }
   
    this.parent.loading = false;
  });
}

}
